// extracted by mini-css-extract-plugin
export default {"blue_button":"elements_blue_button__hrncM","buttonIcon":"elements_buttonIcon__GBK4b"};